export const arrowLeftSVG = `
<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="pswp__icn" width="20" height="20" viewBox="0 0 50 50" fill="none">
<path d="M21.4141 3.2721C21.789 3.64715 21.9997 4.15577 21.9997 4.6861C21.9997 5.21642 21.789 5.72504 21.4141 6.1001L11.5141 16.0001L21.4141 25.9001C21.7784 26.2773 21.98 26.7825 21.9754 27.3069C21.9709 27.8313 21.7605 28.3329 21.3897 28.7037C21.0189 29.0746 20.5173 29.2849 19.9929 29.2894C19.4685 29.294 18.9633 29.0924 18.5861 28.7281L7.2721 17.4141C6.89715 17.039 6.68652 16.5304 6.68652 16.0001C6.68652 15.4698 6.89715 14.9612 7.2721 14.5861L18.5861 3.2721C18.9612 2.89715 19.4698 2.68652 20.0001 2.68652C20.5304 2.68652 21.039 2.89715 21.4141 3.2721Z" fill="currentColor"/>
</svg>
`;

export const closeSVG = `
<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="pswp__icn" width="32" height="32" viewBox="0 0 42 42" fill="none">
<path d="M7.76513 4.8426L15.9998 13.0773L24.1918 4.88527C24.3727 4.69267 24.5907 4.53859 24.8327 4.43228C25.0746 4.32597 25.3355 4.26962 25.5998 4.2666C26.1656 4.2666 26.7082 4.49136 27.1083 4.89144C27.5084 5.29152 27.7331 5.83414 27.7331 6.39994C27.7381 6.66149 27.6896 6.92129 27.5905 7.16342C27.4915 7.40554 27.344 7.62486 27.1571 7.80794L18.8585 15.9999L27.1571 24.2986C27.5087 24.6426 27.7149 25.1084 27.7331 25.5999C27.7331 26.1657 27.5084 26.7084 27.1083 27.1084C26.7082 27.5085 26.1656 27.7333 25.5998 27.7333C25.3279 27.7445 25.0567 27.6992 24.8032 27.6C24.5498 27.5008 24.3198 27.3501 24.1278 27.1573L15.9998 18.9226L7.78646 27.1359C7.60621 27.3221 7.39086 27.4708 7.15286 27.5733C6.91487 27.6758 6.65892 27.7302 6.39979 27.7333C5.834 27.7333 5.29138 27.5085 4.8913 27.1084C4.49122 26.7084 4.26646 26.1657 4.26646 25.5999C4.26149 25.3384 4.31001 25.0786 4.40906 24.8365C4.50811 24.5943 4.6556 24.375 4.84246 24.1919L13.1411 15.9999L4.84246 7.70127C4.49085 7.35729 4.28468 6.89148 4.26646 6.39994C4.26646 5.83414 4.49122 5.29152 4.8913 4.89144C5.29138 4.49136 5.834 4.2666 6.39979 4.2666C6.91179 4.273 7.40246 4.47993 7.76513 4.8426Z" fill="currentColor"/>
</svg>
`;

export const zoomSVG = `
<svg
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  class="pswp__icn"
  width="20"
  height="20"
  viewBox="0 0 42 42"
  fill="none"
>
  <path
    d="M29.0611 29.0611
       C28.9217 29.2009 28.7561 29.3119 28.5738 29.3876
       C28.3915 29.4633 28.196 29.5023 27.9986 29.5023
       C27.8012 29.5023 27.6057 29.4633 27.4234 29.3876
       C27.241 29.3119 27.0754 29.2009 26.9361 29.0611
       L20.9998 23.1248
       C18.6804 24.9047 15.7708 25.7357 12.8613 25.4492
       C9.95169 25.1627 7.26004 23.7802 5.33231 21.5821
       C3.40459 19.3841 2.38514 16.535 2.48078 13.613
       C2.57641 10.6909 3.77996 7.9146 5.84728 5.84728
       C7.9146 3.77996 10.6909 2.57641 13.613 2.48078
       C16.535 2.38514 19.3841 3.40459 21.5821 5.33232
       C23.7802 7.26004 25.1627 9.95169 25.4492 12.8613
       C25.7357 15.7708 24.9047 18.6804 23.1248 20.9998
       L29.0673 26.9411
       C29.3474 27.2232 29.5041 27.6049 29.5029 28.0024
       C29.5017 28.3999 29.3428 28.7807 29.0611 29.0611Z
       M13.9998 22.4998
       C15.681 22.4998 17.3244 22.0013 18.7222 21.0673
       C20.12 20.1333 21.2095 18.8058 21.8528 17.2526
       C22.4961 15.6995 22.6645 13.9904 22.3365 12.3416
       C22.0085 10.6927 21.199 9.17817 20.0102 7.98942
       C18.8215 6.80068 17.3069 5.99113 15.6581 5.66315
       C14.0093 5.33518 12.3002 5.50351 10.747 6.14685
       C9.19385 6.7902 7.86633 7.87966 6.93234 9.27748
       C5.99835 10.6753 5.49983 12.3187 5.49983 13.9998
       C5.50248 16.2534 6.39886 18.4138 7.99234 20.0073
       C9.58583 21.6008 11.7463 22.4972 13.9998 22.4998Z"
    fill="currentColor"
  />

  <path
    d="M9.99983 12.4998H17.9998
       C18.3977 12.4998 18.7792 12.6579 19.0605 12.9392
       C19.3418 13.2205 19.4998 13.602 19.4998 13.9998
       C19.4998 14.3977 19.3418 14.7792 19.0605 15.0605
       C18.7792 15.3418 18.3977 15.4998 17.9998 15.4998H9.99983
       C9.602 15.4998 9.22047 15.3418 8.93917 15.0605
       C8.65786 14.7792 8.49983 14.3977 8.49983 13.9998
       C8.49983 13.602 8.65786 13.2205 8.93917 12.9392
       C9.22047 12.6579 9.602 12.4998 9.99983 12.4998Z"
    fill="currentColor"
  />

  <path
    class="pswp__zoom-icn-bar-v"
    d="M12.4998 9.99983
       C12.4998 9.602 12.6579 9.22047 12.9392 8.93917
       C13.2205 8.65786 13.602 8.49983 13.9998 8.49983
       C14.3977 8.49983 14.7792 8.65786 15.0605 8.93917
       C15.3418 9.22047 15.4998 9.602 15.4998 9.99983
       V17.9998
       C15.4998 18.3977 15.3418 18.7792 15.0605 19.0605
       C14.7792 19.3418 14.3977 19.4998 13.9998 19.4998
       C13.602 19.4998 13.2205 19.3418 12.9392 19.0605
       C12.6579 18.7792 12.4998 18.3977 12.4998 17.9998
       V9.99983Z"
    fill="currentColor"
  />
</svg>
`;
